






























import { Vue, Component, Watch } from 'vue-property-decorator'
import { realtimeEventTarget } from '@/utils/realtime'
import { quit } from '@/utils/window'
import { isElectron } from '@/utils/electron'

@Component
export default class ReconnectDialog extends Vue {
  isVisible: boolean = false
  exitAppButtonVisible: boolean = false

  created() {
    realtimeEventTarget.addEventListener('reconnecting', this.onReconnecting)
    realtimeEventTarget.addEventListener('reconnected', this.onReconnected)
  }

  @Watch('isVisible')
  onDialogVisibilityChanged(visible: boolean) {
    if (visible) {
      setTimeout(() => {
        this.exitAppButtonVisible = true
      }, 5 * 1000)
    } else {
      this.exitAppButtonVisible = false
    }
  }

  onReconnecting() {
    this.isVisible = true
  }

  onReconnected() {
    this.isVisible = false
  }

  beforeDestory() {
    realtimeEventTarget.removeEventListener('reconnecting', this.onReconnecting)
    realtimeEventTarget.removeEventListener('reconnected', this.onReconnected)
  }

  get isElectron() {
    return isElectron()
  }

  close() {
    if (!isElectron()) {
      window.close()
      return
    }

    quit()
  }
}
